import './V_Spacer.css';

function V_Spacer({ style }) {
    return (
        <div className='V_Spacer' style={style}></div>
    );
}

export default V_Spacer;
